skrilla.directive('promotionMilestones',function() {
    return {
        templateUrl: 'directives/promotionMilestones/promotionMilestones.html',
        scope: {
            promotion:"="
        },
        controller: function($scope, searchService, currencyService, modalService, promotionService, cacheService){
            searchService.get("promotions/definitions/" + $scope.promotion.id + "/milestones").then(function(response){
                $scope.milestones = response.data;
            });

            searchService.get("promotions/milestones").then(function(response){
                $scope.milestoneTypes = response.data.filter(function(milestone){
                    return !milestone.name.includes("DEPOSIT") || milestone.name === "DEPOSIT_FUNDS"
                });
            });

            $scope.newClaimerMilestone = {
                promotionDefinitionId: $scope.promotion.id,
                payeeRole: 'CLAIMER'
            }
            $scope.newOwnerMilestone = {
                promotionDefinitionId: $scope.promotion.id,
                payeeRole: 'OWNER'
            }


            $scope.remove = function(id){
                modalService.confirm("Are you sure you'd like to remove this promotion milestone?", function(){
                    searchService.deleteRequest("promotions/definitions/" + $scope.promotion.id + "/milestones/" + id).then(function(response){
                        $scope.milestones = $scope.milestones.filter(function(milestone){return milestone.id !== id});
                    });
                });
            }

            $scope.create = function(payeeRole){
                var newPromotionMilestone = payeeRole === "CLAIMER" ? "newClaimerMilestone" : "newOwnerMilestone";
                modalService.confirm("Are you sure you'd like to create this promotion milestone?", function(){
                    searchService.post("promotions/definitions/" + $scope.promotion.id + "/milestones", $scope[newPromotionMilestone], "New promotion milestone successfully created").then(function(response){
                        $scope[newPromotionMilestone].id = response.data;
                        $scope[newPromotionMilestone].milestoneName = $scope.milestoneTypes.filter(function(milestone){return milestone.id === $scope[newPromotionMilestone].milestoneId})[0].name;
                        $scope.milestones.push($scope[newPromotionMilestone])
                        $scope[newPromotionMilestone] = {
                            promotionDefinitionId: $scope.promotion.id,
                            payeeRole: payeeRole
                        }
                    });
                });
            }

        }
    };
});
